import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import * as powerbi from "powerbi-client";
import Topbar from "./Topbar";
import Sidebar from "./Sidebar";
import "../App.css";

export default function AdminPortal()
{
  const embedRef = useRef(null);
  const user = JSON.parse(localStorage.getItem("user"));
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [dashboards, setDashboards] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);

  // Load dashboards from backend
  useEffect(() =>
  {
    if (!user)
    {
      window.location.href = "/login";
      return;
    }

    axios
      .get("https://bidashboard.miplapp.in/backend/api/dashboards.php")
      .then((res) =>
      {
        setDashboards(res.data);
        if (res.data.length > 0) setSelectedReport(res.data[0].id); // Select first dashboard
      })
      .catch((err) => console.error("Failed to load dashboards", err));
  }, []);

  // Load Power BI report when selectedReport changes
  useEffect(() =>
  {
    if (selectedReport) loadReport(selectedReport);
  }, [selectedReport]);

  const loadReport = async (reportKey) =>
  {
    if (!embedRef.current) return;

    try
    {
      const res = await axios.get(
        `https://bidashboard.miplapp.in/backend/api/embed.php?reportKey=${reportKey}`
      );
      const { embedUrl, embedToken, reportId } = res.data;

      if (!embedUrl || !embedToken || !reportId)
      {
        console.error("Missing embed data", res.data);
        return;
      }

      const powerbiService = new powerbi.service.Service(
        powerbi.factories.hpmFactory,
        powerbi.factories.wpmpFactory,
        powerbi.factories.routerFactory
      );

      embedRef.current.style.width = "100%";
      embedRef.current.style.height = "600px";

      // Reset previous embed
      if (powerbiService && typeof powerbiService.reset === "function")
      {
        powerbiService.reset(embedRef.current);
      } else if (typeof powerbi.reset === "function")
      {
        powerbi.reset(embedRef.current);
      } else
      {
        const el = embedRef.current;
        if (el) while (el.firstChild) el.removeChild(el.firstChild);
      }

      powerbiService.embed(embedRef.current, {
        type: "report",
        tokenType: powerbi.models.TokenType.Embed,
        accessToken: embedToken,
        embedUrl,
        id: reportId,
        settings: {
          panes: { filters: { visible: false }, pageNavigation: { visible: true } },
        },
      });
    } catch (err)
    {
      console.error("Error while loading report:", err);
    }
  };

  return (
    <>
      <Topbar onToggleSidebar={() => setSidebarCollapsed(!sidebarCollapsed)} collapsed={sidebarCollapsed} />
      <Sidebar collapsed={sidebarCollapsed} role={user?.role} />
      <div className={`main-content modern-admin ${sidebarCollapsed ? "collapsed" : ""}`}>
        <div className="welcome-banner">
          <h2>👋 Welcome, {user?.username}</h2>
          <p>Explore your analytics dashboards below</p>
        </div>

        <div className="dashboard-grid">
          {dashboards.map((dash) => (
            <div
              key={dash.id}
              className={`dashboard-card-modern ${selectedReport === dash.id ? "active" : ""}`}
              onClick={() => setSelectedReport(dash.id)}
            >
              <div className="card-content">
                <h3>{dash.title}</h3>
                <p>View detailed insights</p>
              </div>
            </div>
          ))}
        </div>

        <div ref={embedRef} className="dashboard-container-modern"></div>
      </div>
    </>
  );
}
